import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useNavigate } from "react-router";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { tasksId } from "../../../types/activityTasks";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { imgInstruction } from "../../../assets/imgIntruction";
import { ModalInfo } from "../../../components/common/ModalInfo";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	initialDialog: 1,
	intructions: 2,
	dialogTwo: 3,
	dialogthree: 44,
	activityUI: 4,
	success: 5,
	fail: 6,
	viewActivity: 7,
	modalCaja: 900,
	modalFoodService: 800,
	modalRoomCold: 801,
	modalStore: 802,
	modalGondolas: 950,
	finishSection: 1000,
};

const stepThree = {
	Mostrador001: steps.modalCaja,
	Mostrador: steps.modalFoodService,
	Gondola: steps.modalGondolas,
	PlaneRoomCold: steps.modalRoomCold,
	Armario: steps.modalStore,
}


export const SubtopicOneActivityTwo = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.initialDialog);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema1.activities.subtema1], 2);

	useEffect(() => {
		if (loaded) {
			console.log("subtema one Activity one");
			ObserverEmitter.emit(EVENTS.subtopicOne.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);


	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act2_a01)
	})

	ObserverEmitter.on(EVENTS.subtopicOne.activityTwo.showArea, (area) => {
		const selectUi = stepThree[area]
		if (!selectUi) {
			return
		}
		setUiToShow(selectUi)
	});

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.subtopicOne.initScene, 2);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.initialDialog && (
				<>
					<HeaderRedPresentation name="Actividad 2: Áreas de la tienda OXXO." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`¡Vas por buen camino! Ahora observaremos las diferentes áreas que componen a tu Tienda OXXO. Pon mucha atención a las diferentes áreas, ya que cada una de ellas requiere de cuidados específicos.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.viewActivity);
						}}
						percentage={"50%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivity && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1: Imagen en la tienda."
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.dialogthree);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{/* {uiToShow === steps.intructions && (
				<PanelInstrucionHands
					text="Toca encima de las secciones para conocer detalles."
					action={() => {
						setUiToShow(steps.dialogTwo);
					}}
					img={imgInstruction.sub1act2_01}
				/>
			)} */}
			{/* {uiToShow === steps.dialogTwo && (
				<>
					<PanelInstrucionHands
						text="Toca y arrastra con tu dedo para recorrer la tienda."
						action={() => {
							setUiToShow(steps.dialogthree);
						}}
						img={imgInstruction.sub1act2_02}
					/>
				</>
			)} */}
			{uiToShow === steps.dialogthree && (
				<>
					<PanelInstrucionHands
						text="Toca encima sobre los objetos para obtener información."
						action={() => {
							ObserverEmitter.emit(EVENTS.subtopicOne.activityTwo.moveIslanBox);
							setUiToShow(-1);
						}}
						img={imgInstruction.sub1act2_03}
					/>
				</>
			)}
			{uiToShow === -1 && (
				// mobile UI
				<>
					<BarStatusActivies activities={tasksList} />
				</>
			)}
			{uiToShow === steps.modalCaja && (
				<ModalInfo
					title="Isla/Caja"
					description="Las islas o cajas son puntos de venta dentro del área de ventas donde se ubican las cajas registradoras y el personal encargado de procesar las compras de los clientes. Aquí es donde se realiza el pago de los productos."
					action={() => {
						ObserverEmitter.emit(EVENTS.subtopicOne.activityTwo.moveFoodService);
						setUiToShow(steps.activityUI)
					}}
				/>
			)}

			{uiToShow === steps.modalFoodService && (
				<ModalInfo
					title="Food service"
					description="El área de food service es una sección de la tienda donde se ofrecen opciones de comida preparada rápida y conveniente. Puede incluir productos como sándwiches, empanadas, pizzas, burritos y otros alimentos listos para consumir. La función del área es proporcionar opciones de comida rápida y satisfacer las necesidades de los clientes que buscan una solución de comida rápida y práctica."
					action={() => {
						ObserverEmitter.emit(EVENTS.subtopicOne.activityTwo.moveFloorSale);
						setUiToShow(steps.activityUI)
					}}
				/>
			)}

			{uiToShow === steps.modalGondolas && (
				<ModalInfo
					title="Piso de venta"
					description="El piso de venta es el área principal de la tienda donde se encuentran las estanterías, refrigeradores y exhibidores con los productos disponibles para la venta. Aquí es donde los clientes pueden explorar y seleccionar los artículos que desean comprar."
					action={() => {
						ObserverEmitter.emit(EVENTS.subtopicOne.activityTwo.moveRoomColdActTwo);
						setUiToShow(steps.activityUI)
					}}
				/>
			)}

			{uiToShow === steps.modalRoomCold && (
				<ModalInfo
					title="Cuarto frío"
					description="El cuarto frío es una zona especializada en mantener productos refrigerados y congelados. Aquí se encuentran los alimentos y bebidas que requieren mantenerse a temperaturas más bajas para preservar su frescura. La función del cuarto frío es garantizar que los productos perecederos se mantengan en condiciones óptimas para su venta."
					action={() => {
						ObserverEmitter.emit(EVENTS.subtopicOne.activityTwo.moveStoreActTwo);
						setUiToShow(steps.activityUI)
					}}
				/>
			)}

			{uiToShow === steps.modalStore && (
				<ModalInfo
					title="Bodega"
					description="La bodega es un espacio de almacenamiento ubicado detrás del área de ventas. Es dónde se guarda el inventario adicional de productos para reponer las estanterías y refrigeradores de la tienda. La función de la bodega es asegurar que siempre haya suficiente stock disponible para satisfacer la demanda de los clientes."
					action={() => {
						setUiToShow(steps.finishSection);
					}}
				/>
			)}

			{uiToShow === steps.finishSection && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={0}
						dialogModal="Es importante conocer cada punto de nuestra Tienda OXXO para nuestras labores diarias."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 0,
									subtema: tasksId.tema1.activities.subtema1,
								})
							);
							navigate("/home1/tema1/subtema1/activitythree");
						}}
					/>
				</>
			)}
		</>
	);
};
